import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import i18next from 'i18next';
import { useStyles } from './styles';

const EventPurchasedSubmenu: FC = () => {
    const classes = useStyles();

    return (
        <Grid container className={classes.influencerSubmenu}>
            <NavLink className={classes.influencerSubmenuLink} key="/live_events" to="/live_events">
                {i18next.t('NavBarLiveEventsComponentUpcoming')}
            </NavLink>

            <NavLink
                className={classes.influencerSubmenuLink}
                key="/live_events/past_live_events"
                to="/live_events/past_live_events"
            >
                {i18next.t('NavBarLiveEventsComponentPastEvents')}
            </NavLink>

            <NavLink
                className={classes.influencerSubmenuLink}
                key="/live_events/favorite_live_events"
                to="/live_events/favorite_live_events"
            >
                {i18next.t('NavBarLiveEventsComponentFavorites')}
            </NavLink>
        </Grid>
    );
};

export default EventPurchasedSubmenu;
